var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"appear":""}},[_c('vue-loader',{attrs:{"direction":"top-right","image":"/static/images/rotating-ring-loader.gif","text":"Loading...","text-color":"black"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }